import { Component, ViewEncapsulation, OnInit, Inject, ViewChild, ElementRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { DataStateChangeEvent, GridDataResult } from "@progress/kendo-angular-grid";
import { State, process } from "@progress/kendo-data-query";
import { TablerIconsModule } from "angular-tabler-icons";
import { NgScrollbarModule } from "ngx-scrollbar";
import { fromEvent, debounceTime, distinctUntilChanged } from "rxjs";
import { CluContextItem } from "src/app/@clu-fe/apps/m-cashdesk/@models/clucontext.model";
import { ZTicketVaultDbDocumentDaoService, ZTicketVaultDocumentsPerimetre } from "src/app/@clu-fe/apps/m-cashdesk/@zticketvault/zticketvault-db-document-dao.service";
import { ConnectorCashDeskDaoService } from "src/app/@clu-fe/apps/m-cashdesk/cashdesk/connector-cashdesk-dao.service";
import { KendoModule } from "src/app/kendo.module";
import { MaterialModule } from "src/app/material.module";
import { CustomDatePipe } from "src/app/pipe/customDate.pipe";
import { CustomPipesModule } from "src/app/pipe/customPipes.module";
import { MdConnectorCluGhostModeFnZTicketVaultDocumentsService } from "./md-connector-clu-ghostmode-fn-zticketvault-documents.service";
import { CluFeSnackbarService } from "src/app/@clu-fe/apps/@services/clufe-snackbar.service";

@Component({
    selector     : 'md-clu-ghostmode-fn-zticketvault-documents',
    templateUrl  : './md-clu-ghostmode-fn-zticketvault-documents.component.html',
    styleUrls: ['./md-clu-ghostmode-fn-zticketvault-documents.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, MaterialModule, KendoModule, TranslateModule, TablerIconsModule, NgScrollbarModule, CustomPipesModule, CustomDatePipe],
    providers : [ConnectorCashDeskDaoService, MdConnectorCluGhostModeFnZTicketVaultDocumentsService, CluFeSnackbarService]
})
export class MdCluGhostModeFnZTicketVaultDocumentsComponent implements OnInit {

    showTicketPerimetreModal : boolean = false;
    searchTicketPerimetre : ZTicketVaultDocumentsPerimetre = new ZTicketVaultDocumentsPerimetre();
    startupInfos : any = {
        CAISSE_SESSION_ITEMS : [],
    };
    errorMessage = '';
    private cluZVaultDocumentsDataItems: unknown[];
    dataItems: unknown[];
    public gridView: GridDataResult;
    public state: State = { skip: 0, take: 120, sort: [], };
    public height = window.innerHeight - 305;
    public loading: boolean;
    cluContextItem: CluContextItem;
    columns: { pName: string, title: string, pType?: string, hidden: boolean }[] = [
        { pName: 'MD_DOGID', title: 'ID Ticket', hidden: false },
        { pName: 'MD_CAISSE_SESSION', title: 'Session', hidden: false },
        { pName: 'MD_CAISSIER', title: 'Caissier', hidden: true },
        { pName: 'MD_CAISSIER_LIB', title: 'Caissier', hidden: false },
        { pName: 'DO_PIECE_INTERNAL', title: 'Ticket', hidden: false },
        { pName: 'DO_DATE', title: 'Date', hidden: false },
        { pName: 'DO_TYPE_OP', title: 'Type op.', hidden: false },
        { pName: 'DO_SOUCHELIB', title: 'Souche', hidden: false },
        { pName: 'DO_TIERS', title: 'Code client', hidden: false },
        { pName: 'DO_TOTALHT', title: 'Total HT', hidden: false },
        { pName: 'DO_TOTALTTC', title: 'Total TTC', hidden: false },
        { pName: 'DO_MONTANTREGLE', title: 'Total RG', hidden: false },
        { pName: 'DO_SOLDETTC', title: 'Reste', hidden: false },
        { pName: 'NB_LIGNE', title: 'Lignes [NB]', hidden: false },
        { pName: 'DE_INTITULE', title: 'Dépôt', hidden: false },
        { pName: 'DO_REF', title: 'Référence', hidden: false },
        { pName: 'LC_CARTE_NUM', title: 'Carte Fidélité', hidden: true },
        { pName: 'LC_CLIENT_LIB', title: 'Client Fidélité', hidden: true },
        { pName: 'DO_COORD02', title: 'E/02', hidden: true },
        { pName: 'DO_COORD03', title: 'E/03', hidden: true },
        { pName: 'DO_COORD04', title: 'E/04', hidden: true },
        { pName: 'CO_LIB', title: 'Collaborateur', hidden: false },
        { pName: 'MD_SITE', title: 'Site', hidden: false },
        { pName: 'MD_CAISSE_LIB', title: 'Caisse', hidden: false },
    ];
    @ViewChild('cluGrid') cluGrid: any;

    constructor(
        public matDialogRef: MatDialogRef<MdCluGhostModeFnZTicketVaultDocumentsComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private zticketValaultDocumentsDaoService: ZTicketVaultDbDocumentDaoService,
        private connectorCashDeskDaoService: ConnectorCashDeskDaoService,
        private connector: MdConnectorCluGhostModeFnZTicketVaultDocumentsService, 
        private _snackbarService : CluFeSnackbarService,
    )
    {
        this.doGridFetchAllData = this.doGridFetchAllData.bind(this);
    }

    async ngOnInit() {
        this.matDialogRef.keydownEvents().subscribe(event => { if (event.key === "Escape") { this.matDialogRef.close(); } });
        this.startupInfos.CAISSE_SESSION_ITEMS = await this.zticketValaultDocumentsDaoService.doGetCaisseSessionItems_ZTicketVault();
        try {
            this.cluContextItem = await this.connectorCashDeskDaoService.runQuery_doGetCashDeskItem();
            if(this.cluContextItem?.DEVICE?.CAISSE_SESSION) {
                this.searchTicketPerimetre.CAISSE_SESSION_ITEMS = [this.cluContextItem?.DEVICE?.CAISSE_SESSION];
            }
        }
        catch {}
        this.doLoadDbDataItemsAction_ZTicketVault();
    }

    async doLoadDbDataItemsAction_ZTicketVault(){
        this.loading = true;
        const ZVAULT_DATAITEMS = await this.zticketValaultDocumentsDaoService.doGetTicketItems_ZTicketVault(this.searchTicketPerimetre);
        let ZVAULT_DATAITEMS_PARSED = ZVAULT_DATAITEMS.map( (item : any) => {
            let newItem = { ...item };
            newItem.MD_CAISSIER = item.ticket?.ENTETE?.MD_CAISSIER;
            newItem.MD_CAISSIER_LIB = item.ticket?.ENTETE?.MD_CAISSIER_LIB;
            newItem.MD_CAISSE = item.ticket?.ENTETE?.MD_CAISSE;
            newItem.MD_CAISSE_LIB = item.ticket?.ENTETE?.MD_CAISSE_LIB;
            newItem.DO_TYPE_OP = item.ticket?.ENTETE?.DO_TYPE_OP;
            newItem.DO_SOUCHELIB = item.ticket?.ENTETE?.DO_SOUCHELIB;
            newItem.NB_LIGNE = item.ticket?.LIGNES?.length;
            newItem.DE_INTITULE = item.ticket?.ENTETE?.DE_INTITULE;
            newItem.DO_REF = item.ticket?.ENTETE?.DO_REF;
            newItem.DO_TIERS = item.ticket?.ENTETE?.DO_TIERS;
            newItem.LC_CARTE_NUM = item.ticket?.ENTETE?.LC_CARTE_NUM;
            newItem.LC_CLIENT_LIB = item.ticket?.ENTETE?.LC_CLIENT_LIB;
            newItem.DO_COORD02 = item.ticket?.ENTETE?.DO_COORD02;
            newItem.DO_COORD03 = item.ticket?.ENTETE?.DO_COORD03;
            newItem.DO_COORD04 = item.ticket?.ENTETE?.DO_COORD04;
            newItem.CO_LIB = item.ticket?.ENTETE?.CO_LIB;
            newItem.CHECK_STATUS = -1;
            newItem.CHECK_MESSAGE = '';
            return newItem;
        });
        this.loading = false;
        ZVAULT_DATAITEMS_PARSED = ZVAULT_DATAITEMS_PARSED.filter((m => m.DO_TOTALHT != 0));
        this.cluZVaultDocumentsDataItems = JSON.parse(JSON.stringify(ZVAULT_DATAITEMS_PARSED));
        this.dataItems = JSON.parse(JSON.stringify(ZVAULT_DATAITEMS_PARSED));
        this.loadProducts();
    }
    
    public onDataChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.loadProducts();
    }

    public loadProducts(): void {
        this.gridView = process(this.dataItems, this.state);
        setTimeout(() => this.cluGrid.autoFitColumns(), 10);
    }
    
    @ViewChild('gridSearchInput') set gridSearchInput(element : ElementRef) {
        if(element){
            fromEvent(element.nativeElement, 'keyup')
            .pipe( debounceTime(250), distinctUntilChanged())  
            .subscribe(v=> this.onGridSearchInputChange(element.nativeElement.value));
        }
    };
    onGridSearchInputChange(inputValue: string): void {
        let _filters : any = [];
        for(let _column of this.columns) {
            if(_column.pType === 'string') {
                let _filter = {
                    field: _column.pName,
                    operator: "contains",
                    value: inputValue,
                }
                _filters.push(_filter);
            }
        }
        this.dataItems = process(this.cluZVaultDocumentsDataItems, {
            filter: {
                logic: "or",
                filters: _filters,
            },
        }).data;
        this.loadProducts();
    }
    
    doGridFetchAllData(): ExcelExportData {
        var _state : State = this.state;
        _state.skip = 0;
        _state.take = this.gridView.total;
        const result: ExcelExportData =  {
            data: process(this.dataItems, this.state).data
        };
        return result;
    }

    // #region CHECKS
    pickedItems : string[] = [];
    onToggleAllNoneItemsEvent() {
        if (this.pickedItems == undefined) { this.pickedItems = []; }
        if (this.pickedItems.length == this.cluZVaultDocumentsDataItems.length) { 
            this.pickedItems = [];
            this.cluZVaultDocumentsDataItems.forEach((m : any) => { m.Z_CHECKED = false; }); 
        }
        else { 
            this.pickedItems = this.cluZVaultDocumentsDataItems.map((m : any) => m.MD_DOGID);
            this.cluZVaultDocumentsDataItems.forEach((m : any) => { m.Z_CHECKED = true; });
        }
        this.dataItems = JSON.parse(JSON.stringify(this.cluZVaultDocumentsDataItems));
        this.loadProducts();
    }

    onToggleCheckboxItemEvent(item : any){
        if (this.pickedItems == undefined) { this.pickedItems = []; }
        if (this.pickedItems.includes(item.MD_DOGID)){ this.pickedItems = this.pickedItems.filter(m => m != item.MD_DOGID); } 
        else { this.pickedItems.push(item.MD_DOGID); }
    }
    // #endregion 


    // #region CONTROLS
    showProgressBar : boolean = false;
    doRunZVaultTicketDocumentChecksProcess_Session(dataItem : any = undefined){
        this.showProgressBar = true;
        let _checkParams : any = { ITEMS : [] };
        if(dataItem) {
            _checkParams.ITEMS.push({ MD_DOGID : dataItem.MD_DOGID, DO_PIECE_INTERNAL : dataItem.DO_PIECE_INTERNAL, MD_CAISSE_SESSION : dataItem.MD_CAISSE_SESSION, DO_TOTALHT : dataItem.DO_TOTALHT, DO_TOTALTTC : dataItem.DO_TOTALTTC, DO_MONTANTREGLE : dataItem.DO_MONTANTREGLE } );
        }
        else {
            this.pickedItems.forEach((MD_DOGID : string) => {
                let _m : any = this.cluZVaultDocumentsDataItems.find((m : any) => m.MD_DOGID == MD_DOGID);
                if(!!_m) {
                    _checkParams.ITEMS.push({ MD_DOGID : MD_DOGID, MD_CAISSE_SESSION : _m.MD_CAISSE_SESSION, DO_PIECE_INTERNAL : _m.DO_PIECE_INTERNAL, DO_TOTALHT : _m.DO_TOTALHT, DO_TOTALTTC : _m.DO_TOTALTTC, DO_MONTANTREGLE : _m.DO_MONTANTREGLE } );
                }
            });
        }
        if(_checkParams.ITEMS.length == 0) {
            this._snackbarService.displayMessage("WARNING", "Aucun ticket sélectionné pour le contrôle.");
            this.showProgressBar = false;
            return;
        }
        this.connector.doRunZVaultTicketDocumentChecksProcess_Session(_checkParams).subscribe({
            next : (res : any) => {
                this.showProgressBar = false;
                res.ITEMS.forEach((item : any) => {
                    let _m : any = this.cluZVaultDocumentsDataItems.find((m : any) => m.MD_DOGID == item.MD_DOGID);
                    if(!!_m) {
                        _m.CHECK_STATUS = item.CHECK_STATUS;
                        _m.CHECK_MESSAGE = item.CHECK_MESSAGE;
                    }
                });
                this.pickedItems = [];
                this.cluZVaultDocumentsDataItems.forEach((m : any) => { m.Z_CHECKED = false; });
                this.dataItems = JSON.parse(JSON.stringify(this.cluZVaultDocumentsDataItems));
                this.loadProducts();
            }, 
            error : (err : any) => {
                console.error(err);
                if(err.error != undefined && err.error.Message != undefined){ this._snackbarService.displayMessage("ERROR", err.error.Message); }
                else { this._snackbarService.displayMessage("ERROR", "Une erreur est survenue lors de la vérification des éléments.."); }
                this.showProgressBar = false; 
            }
        })
    }

    doSyncZVaultTicketDocumentItem_Session(_dataItem : any){
        console.log(_dataItem);
        if(_dataItem.CHECK_STATUS == -1 || _dataItem.CHECK_STATUS == 1){
            this._snackbarService.displayMessage("ERROR", "Le ticket doit être contrôlé et être en écart ou non présent pour effectuer un envoi.");
            return;
        }
        this.showProgressBar = true;
        this.connector.doSyncZVaultTicketDocumentItem_Session(_dataItem).subscribe({
            next : (res : any) => {
                this.showProgressBar = false;
                this.doRunZVaultTicketDocumentChecksProcess_Session(_dataItem);
            }, 
            error : (err : any) => {
                console.error(err);
                if(err.error != undefined && err.error.Message != undefined){ this._snackbarService.displayMessage("ERROR", err.error.Message); }
                else { this._snackbarService.displayMessage("ERROR", "Une erreur est survenue lors de l'envoi des éléments.."); }
                this.showProgressBar = false; 
            }
        })
    }
    // #endregion 
} 